// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__UT+vn","loading":"Loader_loading__KQCLi"};